/* Delvia — checkout ÖNCESİ zorunlu teslimat/fatura adımı (Patron, 27 Eyl 2026).
   NEDEN: Shopify checkout'unun adres formu değiştirilemez (Plus'ta bile). Adresi
   bizim formumuzla (il → ilçe → mahalle + kurumsal fatura) alıp checkout'a DOLU
   gönderiyoruz. Ölçüldü (27 Eyl, başsız Chrome, misafir): /checkout?checkout[...]
   e-posta/ad/adres/posta kodu/ilçe/il(TR-59) alanlarını dolduruyor, sepet bozulmuyor.
   Eşleme adres sayfamızla aynı: il→province, ilçe→city, mahalle→address2 (Shopify
   formunda ayrı mahalle alanı yok), açık adres→address1.
   Fatura/telefon bilgisi sepet ÖZELLİĞİ olarak yazılır (checkout ekranında görünmez;
   siparişe taşınır). liste dosyası okunamazsa il/ilçe elle yazılır — ödeme ENGELLENMEZ. */
(function () {
  var form = document.querySelector('[data-egebeyi-teslimat]');
  if (!form) return;
  // İl/ilçe/mahalle: Adreslerim ile AYNI bileşen ve veri (assets/delvia-konum.js) —
  // "Ara..." kutulu liste, veri temanın kendi dosyaları, dış servis yok (28 Eyl).
  var K = window.DelviaKonum, Secim = window.DelviaAranabilirSecim;
  var KAYIT = 'delvia.teslimat.v1';
  var $ = function (s) { return form.querySelector(s); };
  var il = $('[name="il"]'), ilce = $('[name="ilce"]'), mah = $('[name="mahalle"]');
  var sIl = new Secim(il, { placeholder: 'Şehir Seçiniz' });
  var sIlce = new Secim(ilce, { placeholder: 'İlçe Seçiniz' });
  var sMah = new Secim(mah, { placeholder: 'Mahalle Seçiniz' });
  var ulke = $('[name="ulke"]'), sehirYd = $('[name="sehir_yd"]'), bolgeYd = $('[name="bolge_yd"]');
  var sUlke = ulke ? new Secim(ulke, { placeholder: 'Ülke Seçiniz', searchPlaceholder: 'Ülke ara…', bayrak: true }) : null;
  function trMi() { return !ulke || ulke.value === 'TR'; }

  // Telefon ülke kodu: Adreslerim ile AYNI seçici (DelviaKonum.telSecici), varsayılan +90; numara E.164 gider.
  var telUlke = $('[name="tel_ulke"]');
  var telKod = K.ulkeler[0];
  function telTR() { return telKod.iso === 'tr'; }
  function telSec(c) {
    telKod = c; telUlke.value = c.iso;
    telEl.placeholder = telTR() ? '5XX XXX XX XX' : 'Telefon numarası';
    telEl.dispatchEvent(new Event('input'));
  }
  // E.164: +<alan kodu><numara>; yurt dışında baştaki ulusal 0 atılır (İtalya hariç).
  function tamTel(d) {
    if (telTR()) return '+90' + d;
    if (telKod.iso !== 'it') d = d.replace(/^0+/, '');
    return '+' + telKod.code.replace(/\D/g, '') + d;
  }

  // JadencySocial sepet pikseli: iki cihazı tek kişide birleştirmek için e-posta/telefon (Patron onayı 15 Eki).
  // YALNIZ SHA-256 özeti gider: Shopify özel olayı mağazadaki TÜM piksellere iletilir, açık değer gönderilmez.
  async function sha256hex(x) {
    var b = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(x));
    return Array.from(new Uint8Array(b)).map(function (n) { return n.toString(16).padStart(2, '0'); }).join('');
  }
  function telOzetGirdisi(t) {
    var d = (t || '').replace(/\D/g, '').replace(/^00/, '');
    if (d.length === 11 && d[0] === '0') d = '9' + d;
    else if (d.length === 10 && d[0] === '5') d = '90' + d;
    return d.length >= 10 && d.length <= 15 ? d : '';
  }
  async function adresOlayi(v) {
    var o = {};
    try {
      var ep = (v.eposta || '').trim().toLowerCase();
      if (ep.indexOf('@') > -1) o.em_ozet = await sha256hex(ep);
      var d = v.telefon ? telOzetGirdisi(tamTel(v.telefon)) : '';
      if (d) o.ph_ozet = await sha256hex(d);
      if (o.em_ozet || o.ph_ozet) o.countryCode = 'TR';
    } catch (e) { o = {}; }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('jadency_adres_girildi', o); } catch (e) {}
  }


  function tr(s) { return (s || '').trim().toLocaleLowerCase('tr-TR'); }
  // Adım adım açılış: üst alan dolmadan alttaki GİZLİ. Gizli adres/posta kodu disabled —
  // gizli required alan Chrome'da gönderimi sessizce durdurur (28 Eyl).
  function adimlar() {
    var t = trMi();
    var ac = {
      il: t, ilce: t && !!il.value, mahalle: t && !!(il.value && ilce.value), yurtdisi: !t,
      adres: t ? !!(il.value && ilce.value && mah.value) : !!(sehirYd && sehirYd.value.trim())
    };
    Object.keys(ac).forEach(function (k) {
      var el = form.querySelector('[data-adim="' + k + '"]');
      if (el && el.hidden === ac[k]) el.hidden = !ac[k];
    });
    ['adres', 'baslik'].forEach(function (k) { var i = $('[name="' + k + '"]'); if (i) i.disabled = !ac.adres; });
    // Adres Başlığı yalnız adres hesaba kaydedilecekse zorunlu (misafir / kaydetmeyen takılmasın).
    var bas = $('[name="baslik"]'), kay = $('[name="hesaba_kaydet"]');
    if (bas) bas.required = !!(kay && kay.checked);
    [sehirYd, bolgeYd].forEach(function (i) { if (i) i.disabled = t; });
  }
  // new Option: listeden gelen ad HTML olarak yorumlanmaz (XSS — Opus incelemesi).
  function secenek(sel, sec, liste, bos) {
    sel.innerHTML = '';
    sel.add(new Option(bos, ''));
    liste.forEach(function (x) { sel.add(new Option(x, x)); });
    sel.disabled = !liste.length;
    sec.disableManualEntry(true);
    sec.syncWithSelect();
    adimlar();
  }
  // Liste gelmezse alan elle yazılan kutuya döner — sipariş akışı durmasın.
  // Bileşen elle kutusunun kilidini yalnız syncWithSelect'te açar; burada açıkça açılır
  // (yoksa kutu görünür ama yazılamaz — 28 Eyl ölçümü).
  function elle(sel, sec, deger) {
    sel.disabled = false;
    sec.displayInput.disabled = false; sec.manualInput.disabled = false;
    if (deger) sec.manualInput.value = deger;
    sec.enableManualEntry(false);
    adimlar();
  }
  // Listede varsa seç, yoksa elle yazılmış değer olarak koy.
  function degerVer(sel, sec, deger) {
    if (!deger) return;
    var o = Array.from(sel.options).find(function (x) { return x.value && tr(x.value) === tr(deger); });
    if (o) { sel.value = o.value; sec.syncWithSelect(); adimlar(); }
    else elle(sel, sec, deger);
  }

  async function illeriYukle() {
    try {
      var l = await K.iller();
      secenek(il, sIl, l.map(function (p) { return p.a; })
        .sort(function (a, b) { return a.localeCompare(b, 'tr'); }), 'Şehir Seçiniz');
    } catch (e) {
      elle(il, sIl); elle(ilce, sIlce); elle(mah, sMah);
    }
  }
  async function ilceleriDoldur() {
    secenek(mah, sMah, [], 'Mahalle Seçiniz');
    try {
      var p = await K.ilBul(il.value);
      if (!p) throw new Error('il listede yok');
      secenek(ilce, sIlce, p.i.slice(), 'İlçe Seçiniz');
    } catch (e) {
      if (il.value) { elle(ilce, sIlce); elle(mah, sMah); }
      else secenek(ilce, sIlce, [], 'İlçe Seçiniz');
    }
  }
  async function mahalleleriDoldur() {
    if (!il.value || !ilce.value) { secenek(mah, sMah, [], 'Mahalle Seçiniz'); return; }
    try {
      secenek(mah, sMah, await K.mahalleler(il.value, ilce.value), 'Mahalle Seçiniz');
    } catch (e) {
      elle(mah, sMah);
    }
  }

  // Fatura türü: Kurumsal seçilince firma/VKN/vergi dairesi zorunlu.
  function faturaGoster() {
    var kurumsal = ($('[name="fatura_turu"]:checked') || {}).value === 'Kurumsal';
    form.querySelectorAll('[data-kurumsal]').forEach(function (el) {
      el.hidden = !kurumsal;
      el.querySelectorAll('input').forEach(function (i) { if (i.type !== 'checkbox') i.required = kurumsal; });
    });
  }

  // Son girilen bilgiyi hatırla — YALNIZ misafirde, 30 gün, fatura kimliği (VKN/firma/
  // vergi dairesi) HİÇ saklanmaz (KVKK, Opus incelemesi). Üye hesaptaki adresi kullanır.
  var GUN30 = 30 * 24 * 3600 * 1000;
  function kaydet(v) {
    if (window.EGEBEYI_CUSTOMER) return;
    var s = {};
    ['ad', 'soyad', 'eposta', 'telefon', 'adres', 'baslik', 'il', 'ilce', 'mahalle', 'ulke', 'tel_ulke', 'sehir_yd', 'bolge_yd']
      .forEach(function (k) { if (v[k]) s[k] = v[k]; });
    s._t = Date.now();
    try { localStorage.setItem(KAYIT, JSON.stringify(s)); } catch (e) {}
  }
  function oku() {
    if (window.EGEBEYI_CUSTOMER) return null;
    try {
      var s = JSON.parse(localStorage.getItem(KAYIT) || 'null');
      if (s && Date.now() - (s._t || 0) > GUN30) { localStorage.removeItem(KAYIT); return null; }
      return s;
    } catch (e) { return null; }
  }

  // zorla: kayıtlı adres seçilince dolu alanların üzerine de yazılır (seçim = o adres).
  async function doldur(v, zorla) {
    if (!v) return;
    var kayitliKod = v.tel_ulke && K.ulkeler.find(function (c) { return c.iso === v.tel_ulke; });
    if (kayitliKod) {
      var bayrakImg = form.querySelector('[data-selected-flag]');
      bayrakImg.src = K.bayrakUrl(kayitliKod.iso); bayrakImg.setAttribute('data-iso', kayitliKod.iso);
      var kodYazi = form.querySelector('[data-selected-code]'); if (kodYazi) kodYazi.textContent = kayitliKod.code;
      telSec(kayitliKod);
    }
    if (v.ulke && ulke && Array.from(ulke.options).some(function (o) { return o.value === v.ulke; })) { ulke.value = v.ulke; sUlke.syncWithSelect(); }
    ['ad', 'soyad', 'eposta', 'telefon', 'adres', 'baslik', 'firma', 'vkn', 'vergi_dairesi', 'sehir_yd', 'bolge_yd']
      .forEach(function (k) { var i = $('[name="' + k + '"]'); if (i && (zorla ? k in v : !i.value && v[k])) i.value = v[k] || ''; });
    adimlar();
    // Kayıtlı telefon +90555… gelir; bayrak zaten +90 gösterdiği için 5XX XXX XX XX'e indir.
    var t = $('[name="telefon"]'); if (t && t.value) t.dispatchEvent(new Event('input'));
    var ft = $('[name="fatura_turu"][value="' + (v.fatura_turu || 'Bireysel') + '"]');
    if (ft) ft.checked = true;
    if (v.il) {
      degerVer(il, sIl, v.il);
      if (il.value && !sIl.manualWrapper.classList.contains('active')) await ilceleriDoldur();
      else { elle(ilce, sIlce); elle(mah, sMah); }
      degerVer(ilce, sIlce, v.ilce);
      if (ilce.value && !sIlce.manualWrapper.classList.contains('active')) await mahalleleriDoldur();
      else elle(mah, sMah);
      degerVer(mah, sMah, v.mahalle);
    }
    faturaGoster();
  }

  function telefonTemiz(t) {
    var d = (t || '').replace(/\D/g, '');
    if (!telTR()) return d;
    if (d.indexOf('90') === 0 && d.length === 12) d = d.slice(2);
    if (d.indexOf('0') === 0 && d.length === 11) d = d.slice(1);
    return d;
  }

  // Yazarken kısıtla (Patron, 28 Eyl): telefon yalnız rakam, 10 hane, 5XX XXX XX XX;
  // e-postada boşluk/Türkçe karakter giremez. Otomatik doldurma (+90 / 0 önekli) de sadeleşir.
  var EPOSTA_RE = /^[a-z0-9._%+-]+@[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/i;
  var telEl = form.elements.telefon, epEl = form.elements.eposta;
  function telefonBicimle(d) {
    return [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter(Boolean).join(' ');
  }
  telEl.setAttribute('inputmode', 'numeric');
  K.telSecici(telEl.closest('.phone-input-wrapper'), telSec);
  telEl.addEventListener('input', function () {
    if (!telTR()) {
      // Yurt dışı: yalnız rakam, ülke kodu olmadan (E.164 en çok 15 hane).
      var y = telEl.value.replace(/\D/g, '').slice(0, 14);
      if (y !== telEl.value) telEl.value = y;
      telEl.setCustomValidity(y && y.length < 4 ? 'Telefon numarasını ülke kodu olmadan yazın' : '');
      uyari(telEl);
      return;
    }
    // +90 / 0090 / 0 önekini harf harf yazarken de ayıkla: önek ancak ardından 5 gelince kesinleşir.
    var d = telEl.value.replace(/\D/g, '').replace(/^00/, '');
    if (/^90?$/.test(d) || /^905/.test(d)) d = d.replace(/^90/, '');
    d = d.replace(/^0+/, '').slice(0, 10);
    // İmleç korunur: imleçten önceki rakam sayısı, biçimlemeden sonra aynı rakamın arkasına
    // konur. Yoksa her tuşta imleç sona atlıyor, ortadan silme/düzeltme çalışmıyordu (Opus, 28 Eyl).
    var once = telEl.value.slice(0, telEl.selectionStart || 0).replace(/\D/g, '').length;
    var fazla = telEl.value.replace(/\D/g, '').length - d.length;
    var hedef = Math.max(0, Math.min(d.length, once - fazla));
    var yeni = telefonBicimle(d), poz = 0, say = 0;
    while (poz < yeni.length && say < hedef) { if (/\d/.test(yeni[poz])) say++; poz++; }
    telEl.value = yeni;
    if (document.activeElement === telEl) telEl.setSelectionRange(poz, poz);
    telEl.setCustomValidity(d && (d.length !== 10 || d[0] !== '5') ? 'Cep telefonu 5 ile başlayan 10 hane olmalı (5XX XXX XX XX)' : '');
    uyari(telEl);
  });
  epEl.addEventListener('input', function () {
    // Yalnız boşluk atılır. Türkçe harf SESSİZCE silinmez (ayşe@ → aye@ yanlış adrese gider);
    // bırakılır ve uyarı verilir, müşteri kendisi düzeltir (Opus, 28 Eyl).
    var t = epEl.value.replace(/\s/g, '');
    if (t !== epEl.value) epEl.value = t;
    var trHarf = /[çğıöşüÇĞİÖŞÜ]/.test(t);
    epEl.setCustomValidity(!t ? '' : trHarf ? 'E-postada Türkçe karakter olamaz (ç, ğ, ı, ö, ş, ü)'
      : !EPOSTA_RE.test(t) ? 'Geçerli bir e-posta yazın (ör. ad@ornek.com)' : '');
    if (trHarf) { epEl.dataset.dokundu = '1'; }
    uyari(epEl);
  });
  // Uyarı alanın altında; reportValidity KULLANILMAZ — odağı geçersiz alana geri çekip
  // müşteriyi kilitliyordu (ölçüldü: e-postaya yazılanlar telefona gidiyordu).
  function uyari(el) {
    // Telefon bayraklı sarmalayıcının içinde; uyarı satırı sarmalayıcının ALTINA gelir.
    var yer = el.closest('.phone-input-wrapper') || el;
    var n = yer.nextElementSibling;
    if (!n || !n.hasAttribute('data-uyari')) {
      n = document.createElement('small'); n.setAttribute('data-uyari', '');
      n.style.cssText = 'display:block;color:#a8201a;font-size:1.2rem;margin-top:.3rem;';
      yer.after(n);
    }
    n.textContent = el.dataset.dokundu ? el.validationMessage : '';
  }
  [telEl, epEl].forEach(function (el) {
    el.addEventListener('blur', function () { if (el.value) { el.dataset.dokundu = '1'; uyari(el); } });
  });

  form.addEventListener('input', function (e) { if (e.target === sehirYd) adimlar(); });
  form.addEventListener('change', function (e) {
    adimlar();
    if (e.target === il && il.value !== il.dataset.son) { il.dataset.son = il.value; ilce.dataset.son = ''; ilceleriDoldur(); }
    else if (e.target === ilce && ilce.value !== ilce.dataset.son) { ilce.dataset.son = ilce.value; mahalleleriDoldur(); }
    else if (e.target.name === 'fatura_turu') faturaGoster();
  });

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    var hata = $('[data-hata]');
    hata.hidden = true;
    var fd = new FormData(form);
    var v = {};
    fd.forEach(function (val, k) { v[k] = (val || '').toString().trim(); });
    v.il = il.value.trim(); v.ilce = ilce.value.trim(); v.mahalle = mah.value.trim();
    var tr = trMi();
    v.ulke = tr ? 'TR' : ulke.value; v.tel_ulke = telKod.iso;
    if (!tr && !v.sehir_yd) {
      hata.textContent = 'Şehir yazın.';
      hata.hidden = false; return;
    }
    if (tr && (!v.il || !v.ilce || !v.mahalle)) {
      hata.textContent = 'Şehir, ilçe ve mahalle seçin (listede yoksa "Listede yok" ile yazabilirsiniz).';
      hata.hidden = false; return;
    }
    v.telefon = telefonTemiz(v.telefon);
    if (!EPOSTA_RE.test(v.eposta)) {
      hata.textContent = 'E-posta adresini doğru yazın (ör. ad@ornek.com).';
      hata.hidden = false; epEl.focus(); return;
    }
    if (telTR() ? (v.telefon.length !== 10 || v.telefon[0] !== '5') : (v.telefon.length < 4 || v.telefon.length > 14)) {
      hata.textContent = telTR() ? 'Telefonu 5XX XXX XX XX biçiminde yazın (kargo firması arayacak).' : 'Telefon numarasını ülke kodu olmadan yazın (kargo firması arayacak).';
      hata.hidden = false; return;
    }
    if (v.fatura_turu === 'Kurumsal' && !/^\d{10,11}$/.test(v.vkn || '')) {
      hata.textContent = 'Vergi / TC kimlik numarası 10 ya da 11 haneli olmalı.';
      hata.hidden = false; return;
    }
    var btn = $('[type="submit"]');
    btn.disabled = true; btn.textContent = 'Ödemeye geçiliyor…';
    kaydet(v);

    var mahalle = !tr ? '' : v.mahalle && !/mah/i.test(v.mahalle) ? v.mahalle + ' Mah.' : v.mahalle;
    var tel = tamTel(v.telefon);
    var attr = { 'Telefon': tel, 'Fatura Türü': v.fatura_turu || 'Bireysel' };
    if (tr) { attr['İl'] = v.il; attr['İlçe'] = v.ilce; attr['Mahalle'] = v.mahalle; }
    else { attr['Ülke'] = v.ulke; attr['Şehir'] = v.sehir_yd; attr['Bölge'] = v.bolge_yd || ''; }
    if (v.fatura_turu === 'Kurumsal') {
      attr['Firma Unvanı'] = v.firma; attr['VKN/TCKN'] = v.vkn;
      attr['Vergi Dairesi'] = v.vergi_dairesi; attr['e-Fatura Mükellefi'] = v.e_fatura ? 'Evet' : 'Hayır';
    }
    try {
      await fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attr })
      });
      // Üye müşteri: adres hesabına da yazılır (adres sayfamızla aynı veri biçimi).
      if (window.egebeyiCustomer && window.EGEBEYI_CUSTOMER && fd.get('hesaba_kaydet')) {
        var ex = tr ? { fatura_turu: v.fatura_turu || 'Bireysel', il: v.il, ilce: v.ilce, mahalle: v.mahalle } : { fatura_turu: v.fatura_turu || 'Bireysel' };
        if (v.fatura_turu === 'Kurumsal') { ex.firma_adi = v.firma; ex.vkn = v.vkn; ex.vd = v.vergi_dairesi; ex.e_fatura = !!v.e_fatura; }
        try {
          await window.egebeyiCustomer.createAddress({
            // Adres Başlığı Adreslerim'deki gibi address.company'ye; firma adı yalnız extras'ta (firma_adi).
            first_name: v.ad, last_name: v.soyad, company: v.baslik || '', address1: v.adres,
            // adres sayfamız mahalleyi eksiz saklar (checkout'a "… Mah." gider)
            address2: tr ? v.mahalle : '', city: tr ? v.ilce : v.sehir_yd, province: tr ? v.il : (v.bolge_yd || ''),
            country: v.ulke, phone: tel, extras: ex
          });
        } catch (err) { /* adres kaydı düşse de ödeme sürer */ }
      }
    } catch (err) { /* sepet özelliği yazılamasa da ödeme sürer */ }

    var q = new URLSearchParams();
    if (v.eposta) q.set('checkout[email]', v.eposta);
    var s = 'checkout[shipping_address]';
    q.set(s + '[first_name]', v.ad); q.set(s + '[last_name]', v.soyad);
    q.set(s + '[address1]', v.adres); q.set(s + '[address2]', mahalle);
    q.set(s + '[city]', tr ? v.ilce : v.sehir_yd);
    q.set(s + '[province]', tr ? await K.ilKodu(v.il) : (v.bolge_yd || ''));
    q.set(s + '[country]', v.ulke);
    q.set(s + '[phone]', tel);
    if (v.fatura_turu === 'Kurumsal' && v.firma) q.set(s + '[company]', v.firma);
    // JadencySocial sepet pikseli 'adres_girildi' sayar; yalnız e-posta/telefon SHA-256 özeti gider (15 Eki).
    await adresOlayi(v);
    window.location.href = '/checkout?' + q.toString();
  });

  // Checkout'tan geri tuşuyla dönülünce sayfa önbellekten gelir; düğme kilitli kalmasın.
  window.addEventListener('pageshow', function () {
    var b = $('[type="submit"]');
    if (b) { b.disabled = false; b.textContent = 'Ödemeye geç'; }
  });

  var kayitli = $('[name="kayitli_adres"]');
  if (kayitli) {
    var sKayitli = new Secim(kayitli, { placeholder: 'Kayıtlı adres seçin' });
    kayitli.addEventListener('change', function () {
      var a = (window.EGEBEYI_ADRESLER || [])[kayitli.value];
      var kaydet = $('[name="hesaba_kaydet"]');
      // Kayıtlı adres seçildiyse yeniden kaydetme (mükerrer adres olmasın); "Yeni adres" alanları boşaltır.
      if (kaydet) kaydet.checked = !a;
      if (!a) {
        // "Yeni adres": önceki adresin il/ilçe/mahallesi de temizlenir (inceleme 28 Eyl).
        il.value = ''; sIl.disableManualEntry(true); sIl.syncWithSelect();
        il.dataset.son = ''; ilce.dataset.son = '';
        ilceleriDoldur();
      }
      doldur(a || { ad: '', soyad: '', telefon: '', adres: '', baslik: '' }, true);
    });
  }
  illeriYukle().then(function () { return doldur(oku() || window.EGEBEYI_TESLIMAT_VARSAYILAN); });
  faturaGoster();
})();
